<script setup lang="ts">
import { useRoute } from 'vue-router';
import homeJson from '@/assets/json/home.json';
import GamesCustomizable from '@/components/casino/GamesCustomizable.vue';

const route = useRoute();
const sectionSlug = route.params.sectionSlug;

const section = homeJson.HomeGames.find(
  (section) => section.button?.to?.split('/ver-todos/')[1] === sectionSlug,
);

const banner = section?.banner;
const games = section?.child?.filter((game) => game) || [];
const title = section?.title;
</script>

<template>
  <GamesCustomizable
    :banner="banner"
    :games="games"
    :title="title"
  />
</template>
